module.exports = __webpack_public_path__ + "static/img/7.a71382c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/7.png
// module id = 73TM
// module chunks = 0